module.exports = __webpack_public_path__ + "img/CRM.329cb1d5.png";